import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { ProductsGetAssociatedEInvoiceSymbolsQuery, ProductsGetAssociatedEInvoiceSymbolsQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ProductsGetAssociatedEInvoiceSymbolsQuery)
@Wrapper(ProductsGetAssociatedEInvoiceSymbolsQueryHandlerBase)
export class ProductsGetAssociatedEInvoiceSymbolsQueryHandler {
    public constructor(
        http: Http
    ) { }
}
